import { OfferListItem } from '@features/offers/interfaces/offersInterface';
import { Divider, Flex, Skeleton, Table } from 'antd';
import { ColumnType } from 'antd/lib/table';

type SkeletonOfferExhibitionProps = {
  columnsTable?: ColumnType<OfferListItem>[];
};

export function SkeletonOfferExhibition({
  columnsTable,
}: SkeletonOfferExhibitionProps) {
  const skeletonComponent = (
    <Skeleton active paragraph={false} style={{ width: 70 }} />
  );

  // Adiciona skeletons em todas as colunas da tabela
  const dataSkeletons = Array.from({ length: 5 }).map((_, index) => {
    const row: any = {};
    columnsTable?.forEach(column => {
      row[column.key as string] = skeletonComponent;
    });
    row.key = index;
    return row;
  });

  // Se houver onRender nas colunas, substitui o skeleton pelo resultado de onRender
  const columnsWithRender = columnsTable?.map(column => {
    if (column.render) {
      return {
        ...column,
        render: () => skeletonComponent,
      };
    }
    return column;
  });

  return (
    <Flex vertical data-testid='skeleton-offer-exhibition'>
      <Flex vertical>
        <Skeleton active paragraph={false} style={{ width: 470 }} />

        <Flex justify='space-between' style={{ marginTop: 4 }}>
          <Skeleton active paragraph={false} style={{ width: 261 }} />
          <Skeleton active paragraph={false} style={{ width: 261 }} />
        </Flex>
      </Flex>
      <Divider />

      <Skeleton.Button active size='large' block />

      <Table
        columns={columnsWithRender}
        dataSource={dataSkeletons}
        pagination={false}
        style={{ marginTop: 16 }}
      />
    </Flex>
  );
}
